import { EventStartCall } from '@revenuewell/front-end-bundle';
import { LwpPhoneWidget, useLwpActions } from '@revenuewell/widget-legacy-phone';
import { useEventBus } from 'apps/wrapper/src/hooks/use-event-bus';
import { useLocations } from 'apps/wrapper/src/hooks/use-locations';
import { FC, useEffect } from 'react';

export interface Phone1LoaderProps {
  onPatientProfileClick: (phoneNumber: string) => void;
}

export const Phone1Loader: FC<Phone1LoaderProps> = (props) => {
  const { onPatientProfileClick } = props;
  const { listen } = useEventBus();
  const { call: lwpCall } = useLwpActions();
  const { selectedLocation, locations } = useLocations();

  useEffect(
    () =>
      listen('startCall', (event) => {
        const { data } = event as EventStartCall;
        lwpCall(data.phoneNumber);
      }),
    [selectedLocation, locations]
  );

  return (
    <LwpPhoneWidget
      events={{
        onPatientProfileClick: onPatientProfileClick
      }}
    />
  );
};
